import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { BackgroundV2 as Background } from '@alfa-bank/site-background-v2';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';

import styles from './styles/desktop.css';
import { BenefitsBlockV2LayoutDesktop as Component } from './layouts/desktop';
import type { TBenefitsBlockV2DepsDesktop, TBenefitsBlockV2PropsDesktop } from './models/desktop';

export const BenefitsBlockV2Desktop = createWidget<
    TBenefitsBlockV2DepsDesktop,
    TBenefitsBlockV2PropsDesktop
>(
    {
        Background,
        Block,
        styles,
    },
    { priorityStyler: true }
)(Component);
